"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _utils = require("../../../../../../../../../../common/utils");

require("./_active-campaign-post.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function PostItem(props) {
  var post = props.post,
      onViewPost = props.onViewPost;
  var assetId = post.assetId,
      thumbnailUrl = post.thumbnailUrl;
  return _react.default.createElement(_uiKit.List.CardItem, {
    className: "active-campaign-post",
    onClick: onViewPost,
    smallestCoverImage: true,
    customCoverImage: assetId || thumbnailUrl ? _react.default.createElement(_commonReact.AssetPreview, _extends({}, (0, _utils.buildAssetPreviewProps)({
      assetId: assetId,
      thumbnailUrl: thumbnailUrl
    }), {
      hideFileTypeIcon: true
    })) : null,
    coverImageProps: {
      defaultImageIcon: 'guide',
      defaultIconSize: 40
    }
  }, _react.default.createElement(_uiKit.Text, {
    heading5: true,
    ellipsisOverflow: true,
    noMargin: true,
    centered: true
  }, post.title));
}

var _default = PostItem;
exports.default = _default;